// One person's status on a puzzle, as on the Home mockup: "You · not started",
// "You · in progress · 12:40", "Player 2 · solved" (her time only once you've finished too).
import type { PersonStatus } from '@zinc/shared';
import { InProgressMark, NotStartedMark, SolvedMark } from './icons';
import { formatTime } from './solve/SolveHeader';

export function statusText(status: PersonStatus | null, own: boolean): string {
  const progress = status?.progress ?? 'not-started';
  const time = status?.timeMs != null ? formatTime(status.timeMs) : null;
  if (progress === 'solved') return time ?? 'solved';
  if (progress === 'in-progress') return own && time ? `in progress · ${time}` : 'in progress';
  return 'not started';
}

export function StatusLine({
  who,
  status,
  own = false,
}: {
  who: string;
  status: PersonStatus | null;
  own?: boolean;
}) {
  const progress = status?.progress ?? 'not-started';
  return (
    <span className="flex items-center gap-1.5">
      {progress === 'solved' ? (
        <SolvedMark size={14} />
      ) : progress === 'in-progress' ? (
        <InProgressMark size={14} />
      ) : (
        <NotStartedMark />
      )}
      <span className="min-w-0 truncate">
        {who} · {statusText(status, own)}
      </span>
    </span>
  );
}
